<div [formGroup]="parentForm">
    <mat-form-field class="example-full-width" style="margin: 5px; width: 400px;" *ngIf="!isKendo">
        <!--<button type="button" class="btn btn-light float-right" title="Clear" (click)="clearOption()" *ngIf="isShowClearButton">
            <i class="fas fa-times"></i>
        </button>-->
        <input matInput #autoTrigger="matAutocompleteTrigger"
               [placeholder]="placeholder"
               [formControlName]="ctrlName"
               [attr.aria-label]="ariaLabel"
               [matAutocomplete]="customer"
               [attr.disabled]="isDisabled"
               [attr.required]="isRequired"
               (keydown.enter)="$event.preventDefault(); chooseActiveCustomer($event)"
               (keydown.Tab)="chooseActiveCustomer($event)"
               (blur)="optionBlurred()" [(ngModel)]="displayValue">
        <mat-autocomplete #customer="matAutocomplete" [displayWith]="displayCustomer" (optionSelected)="optionChanged($event)" (focusout)="optionBlurred()">
            <mat-option style="line-height:1.2;height:50px;" *ngFor="let customer of filteredCustomers" [value]="customer">
                {{customer!.customerCode}} - {{customer!.name}}<br />
                <small style="color:#999999;">{{customer!.address1}}, {{customer!.cityST}}</small>
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="!isValid()">{{errorDetail}}</mat-error>
    </mat-form-field>
    <div *ngIf="isKendo">
        <!--https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/filtering/-->
        <kendo-autocomplete [data]="filteredCustomers"
                            [formControlName]="ctrlName"
                            valueField="customerCode"
                            [filterable]="true"
                            (filterChange)="getCustomerLookup($event)"
                            (valueChange)="optionChanged($event)"
                            placeholder="{{placeholder}}"
                            [disabled]="isDisabled"
                            [required]="isRequired">
            <ng-template kendoAutoCompleteItemTemplate let-dataItem>
                <div style="line-height:1.2;height:50px;z-index:5;">
                    {{dataItem.customerCode}} - {{dataItem.name}}<br />
                    <small style="color:#999999;">{{dataItem.address1}}, {{dataItem.cityST}}</small>
                </div>
            </ng-template>
        </kendo-autocomplete>
    </div>
</div>
